PP.PlayerHeadController = class PlayerHeadController {
    constructor() {
    }
};